import apiHandler from '../apiHandler';
import { METHOD } from '../constants';
import { PATHS } from '../utils';

const fetchDropDownData = async (
  authorization: string,
): Promise<unknown> => {
  const response = await apiHandler({
    url: PATHS.GET_DROPDOWNDATA,
    method: METHOD.GET,
    headers: { authorization }    
  });
  if (!response.ok) throw new Error(response.status + "");
  return (await response.json()) as Promise<unknown>;
};

export default fetchDropDownData;